import styled from "styled-components";

export const StyledSuccessCheckout = styled.div`
  width: 1200px;
  max-width: 100%;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 50px auto 50px;
  gap: 20px;
 

  .wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    gap: 20px;
  }
`;
